import riot from 'riot';
import events from '../src/events.js';
riot.tag2('telemetry-charts', '<div class="card" each="{c in chartTypes}" style="margin-top: 5px;"> <header class="card-header"> <p class="card-header-title"> {c} Chart </p> </header> <div class="card-content"> <div class="content"> <canvas id="measurementsChart_{c}"></canvas> </div> </div> </div>', '', '', function(opts) {
        var self = this;
        self.chartTypes = []
        self.telemetry_methods = [];
        self.activity_steps = [];

        events.on('telemetry_loaded', function(telemetry) {

            self.telemetry_methods = self.parent.telemetry.map(t => t.method);
            self.activity_steps = self.parent.telemetry.map(t => t.activity_step);

            self.telemetry_methods = [...new Set(self.telemetry_methods)];
            self.activity_steps = [...new Set(self.activity_steps)];
            self.buildCharts(undefined);
        });

        this.showChartsClick = function(e) {
            self.showChart = !self.showChart;
            if (self.showChart) {
                self.buildCharts();
            } else {
                self.update();
            }
        }.bind(this)

        this.buildCharts = function(e) {
            self.chartTypes = ['Line', 'Bar', 'Pie', 'Doughnut', 'Radar', 'Polar Area', 'Bubble', 'Scatter'];
            self.update();
        }.bind(this)
});
